import FeatureList from './FeatureList';
import Container from 'common/components/Container';
import Image from 'next/image';
import { ImageWrapper, FeatureSectionContainer } from './FeatureSection.style';

const BenefSection = ({ slice }) => {
  const isReverse = slice.primary.isreverse;

  return (
    <Container>
      <FeatureSectionContainer isReverse={isReverse}>
        <ImageWrapper>
          <Image
            src={slice.primary.image.url}
            alt={slice.primary.image.alt}
            layout="responsive"
            width={600}
            height={400}
            objectFit="cover"
          />
        </ImageWrapper>
        <FeatureList
          slice={slice}
          isIconList={slice.primary.typelist !== 'List With Icon'}
        />
      </FeatureSectionContainer>
    </Container>
  );
};

export default BenefSection;
